// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : REMOVE UNUSED FUNCTION
// MODFIED DATA : 02-09-2025

import AutoLoanProposalActionTypes from './auto-loan-proposal.types';

/** ***************** SEARCH AUTO LOAN PROPOSAL LIST START *********************** */
export const searchMemberListStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.SEARCH_MEMBER_LIST_START,
	payload: searchData,
});

export const searchMemberListSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.SEARCH_MEMBER_LIST_SUCCESS,
	payload: successData,
});

export const searchMemberListFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.SEARCH_MEMBER_LIST_FAILURE,
	payload: failureData,
});

export const searchMemberListResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.SEARCH_MEMBER_LIST_RESPONSE_RESET,
});

export const searchMemberListResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.SEARCH_MEMBER_LIST_RESPONSE_CHANGED,
});

/** ***************** SEARCH AUTO LOAN PROPOSAL LIST END *********************** */

/** ***************** CREATE AUTO LOAN MEMBER BASIC START *********************** */

export const createAutoLoanMemberBasicStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BASIC_START,
	payload: searchData,
});

export const createAutoLoanMemberBasicSucess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BASIC_SUCCESS,
	payload: successData,
});

export const createAutoLoanMemberBasicFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BASIC_FAILURE,
	payload: failureData,
});

export const createAutoLoanMemberBasicResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BASIC_RESPONSE_RESET,
});

export const createAutoLoanMemberBasicResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BASIC_REPONSE_CHANGED,
});
/** ***************** CREATE AUTO LOAN MEMBER BASIC END *********************** */

/** ***************** CREATE AUTO LOAN MEMBER ADDRESS START *********************** */

export const createAutoLoanMemberAddressStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_ADDRESS_START,
	payload: searchData,
});

export const createAutoLoanMemberAddressSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_ADDRESS_SUCCESS,
	payload: successData,
});

export const createAutoLoanMemberAddressFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_ADDRESS_FAILURE,
	payload: failureData,
});

export const createAutoLoanMemberAddressResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_ADDRESS_RESPONSE_RESET,
});

export const createAutoLoanMemberAddressResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_ADDRESS_REPONSE_CHANGED,
});

/** ***************** CREATE AUTO LOAN MEMBER ADDRESS END *********************** */

/** ***************** CREATE AUTO LOAN MEMBER BANK START *********************** */

export const createAutoLoanMemberBankStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BANK_START,
	payload: searchData,
});

export const createAutoLoanMemberBankSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BANK_SUCCESS,
	payload: successData,
});

export const createAutoLoanMemberBankFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BANK_FAILURE,
	payload: failureData,
});

export const createAutoLoanMemberBankResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BANK_RESPONSE_RESET,
});

export const createAutoLoanMemberBankResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BANK_REPONSE_CHANGED,
});

/** ***************** CREATE AUTO LOAN MEMBER BANK END *********************** */

/** ***************** CREATE AUTO LOAN MEMBER IMAGE START *********************** */
export const createAutoLoanMemberImageStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_IMAGE_START,
	payload: searchData,
});

export const createAutoLoanMemberImageSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_IMAGE_SUCCESS,
	payload: successData,
});

export const createAutoLoanMemberImageFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_IMAGE_FAILURE,
	payload: failureData,
});

export const createAutoLoanMemberImageResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_IMAGE_RESPONSE_RESET,
});

export const createAutoLoanMemberImageResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_IMAGE_REPONSE_CHANGED,
});
/** ***************** CREATE AUTO LOAN MEMBER IMAGE END *********************** */

/** ***************** CREATE AUTO LOAN MEMBER COAPPLICANT START *********************** */
export const createAutoLoanMemberCoapplicantStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_START,
	payload: searchData,
});

export const createAutoLoanMemberCoapplicantSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_SUCCESS,
	payload: successData,
});

export const createAutoLoanMemberCoapplicantFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_FAILURE,
	payload: failureData,
});

export const createAutoLoanMemberCoapplicantResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_RESPONSE_RESET,
});

export const createAutoLoanMemberCoapplicantResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_RESPONSE_CHANGED,
});
/** ***************** CREATE AUTO LOAN MEMBER COAPPLICANT END *********************** */

/** ***************** CREATE AUTO LOAN MEMBER COAPPLICANT DOCUMENT START *********************** */

export const createAutoLoanMemberCoapplicantDocumentStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_START,
	payload: searchData,
});

export const createAutoLoanMemberCoapplicantDocumentSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_SUCCESS,
	payload: successData,
});

export const createAutoLoanMemberCoapplicantDocumentFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_FAILURE,
	payload: failureData,
});

export const createAutoLoanMemberCoapplicantDocumentResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_RESPONSE_RESET,
});

export const createAutoLoanMemberCoapplicantDocumentResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_REPONSE_CHANGED,
});

/** ***************** CREATE AUTO LOAN MEMBER COAPPLICANT DOCUMENT END *********************** */

/** ***************** CREATE AUTO LOAN MEMBER VEHICLE START *********************** */

export const createAutoLoanMemberVehicleStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_START,
	payload: searchData,
});

export const createAutoLoanMemberVehicleSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_SUCCESS,
	payload: successData,
});

export const createAutoLoanMemberVehicleFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_FAILURE,
	payload: failureData,
});

export const createAutoLoanMemberVehicleResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_RESPONSE_RESET,
});

export const createAutoLoanMemberVehicleResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_REPONSE_CHANGED,
});

/** ***************** CREATE AUTO LOAN MEMBER VEHICLE END *********************** */

/** ***************** CREATE AUTO LOAN MEMBER VEHICLE DOCUMENT START *********************** */

export const createAutoLoanMemberVehicleDocumentStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_START,
	payload: searchData,
});

export const createAutoLoanMemberVehicleDocumentSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_SUCCESS,
	payload: successData,
});

export const createAutoLoanMemberVehicleDocumentFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_FAILURE,
	payload: failureData,
});

export const createAutoLoanMemberVehicleDocumentResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_RESPONSE_RESET,
});

export const createAutoLoanMemberVehicleDocumentResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_REPONSE_CHANGED,
});

/** ***************** CREATE AUTO LOAN MEMBER VEHICLE DOCUMENT END *********************** */

/** ***************** CREATE AUTO LOAN MEMBER BUSINESS START *********************** */

export const createAutoLoanMemberBusinessStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_START,
	payload: searchData,
});

export const createAutoLoanMemberBusinessSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_SUCCESS,
	payload: successData,
});

export const createAutoLoanMemberBusinessFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_FAILURE,
	payload: failureData,
});

export const createAutoLoanMemberBusinessResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_RESPONSE_RESET,
});

export const createAutoLoanMemberBusinessResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_REPONSE_CHANGED,
});

/** ***************** CREATE AUTO LOAN MEMBER BUSINESS END *********************** */

/** ***************** CREATE AUTO LOAN MEMBER BUSINESS IMAGE START *********************** */

export const createAutoLoanMemberBusinessImageStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_START,
	payload: searchData,
});

export const createAutoLoanMemberBusinessImageSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_SUCCESS,
	payload: successData,
});
export const createAutoLoanMemberBusinessImageFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_FAILURE,
	payload: failureData,
});
export const createAutoLoanMemberBusinessImageResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_RESPONSE_RESET,
});
export const createAutoLoanMemberBusinessImageResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_REPONSE_CHANGED,
});

/** ***************** CREATE AUTO LOAN MEMBER AUTO LOAN INDEX START *********************** */

export const createAutoLoanMemberAutoLoanIndexStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_START,
	payload: searchData,
});

export const createAutoLoanMemberAutoLoanIndexSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const createAutoLoanMemberAutoLoanIndexFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const createAutoLoanMemberAutoLoanIndexResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_RESPONSE_RESET,
});

export const createAutoLoanMemberAutoLoanIndexResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_REPONSE_CHANGED,
});

/** ***************** CREATE AUTO LOAN MEMBER AUTO LOAN INDEX END *********************** */

/** ***************** UPDATE AUTO LOAN MEMBER AUTO LOAN INDEX START *********************** */

export const updateAutoLoanMemberAutoLoanIndexStart = (searchData: any) => ({
	type: AutoLoanProposalActionTypes.UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_START,
	payload: searchData,
});

export const updateAutoLoanMemberAutoLoanIndexSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const updateAutoLoanMemberAutoLoanIndexFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const updateAutoLoanMemberAutoLoanIndexResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_RESPONSE_RESET,
});

export const updateAutoLoanMemberAutoLoanIndexResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_REPONSE_CHANGED,
});

/** ***************** UPDATE AUTO LOAN MEMBER AUTO LOAN INDEX END *********************** */

/** ****************** START AUTO LOAN PROPOSAL FETCH *********************************** */

export const fetchAutoLoanProposalListStart = (fetchData: any) => ({
	type: AutoLoanProposalActionTypes.FETCH_AUTO_LOAN_PROPOSAL_START,
	payload: fetchData,
});

export const fetchAutoLoanProposalListSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.FETCH_AUTO_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const fetchAutoLoanProposalListFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.FETCH_AUTO_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const fetchAutoLoanProposalListResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.FETCH_AUTO_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const fetchAutoLoanProposalListResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.FETCH_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ****************** END AUTO LOAN PROPOSAL FETCH *********************************** */

/** ****************** START AUTO LOAN PROPOSAL GET *********************************** */

export const getAutoLoanProposalDetailStart = (getData: any) => ({
	type: AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_START,
	payload: getData,
});

export const getAutoLoanProposalDetailSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const getAutoLoanProposalDetailFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const getAutoLoanProposalDetailResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const getAutoLoanProposalDetailResponseChnaged = () => ({
	type: AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

export const getAutoLoanResetComponentStart = () => ({
	type: AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_RESET_COMPONENT_START,
});

/** ****************** END AUTO LOAN PROPOSAL GET *********************************** */

/** ****************** START AUTO LOAN PROPOSAL APPROVE *********************************** */

export const approveAutoLoanProposalStart = (approveData: any) => ({
	type: AutoLoanProposalActionTypes.APPROVE_AUTO_LOAN_PROPOSAL_START,
	payload: approveData,
});

export const approveAutoLoanProposalSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.APPROVE_AUTO_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const approveAutoLoanProposalFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.APPROVE_AUTO_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const approveAutoLoanPropsalResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.APPROVE_AUTO_LOAN_PROPODAL_RESPONSE_RESET,
});

export const approveAutoLoanProposalResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.APPROVE_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ****************** END AUTO LOAN PROPOSAL APPROVE *********************************** */

/** ****************** START AUTO LOAN PROPOSAL REVERT *********************************** */

export const revertAutoLoanProposalStart = (revertveData: any) => ({
	type: AutoLoanProposalActionTypes.REVERT_AUTO_LOAN_PROPOSAL_START,
	payload: revertveData,
});

export const revertAutoLoanProposalSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.REVERT_AUTO_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const revertAutoLoanProposalFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.REVERT_AUTO_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const revertAutoLoanProposalResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.REVERT_AUTO_LOAN_PROPODAL_RESPONSE_RESET,
});

export const revertAutoLoanProposalResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.REVERT_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ****************** END AUTO LOAN INDEX REVERT *********************************** */

/** ****************** START AUTO LOAN INDEX DELETE *********************************** */

export const deleteAutoLoanIndexStart = (deleteData: any) => ({
	type: AutoLoanProposalActionTypes.DELETE_AUTO_LOAN_PROPOSAL_START,
	payload: deleteData,
});

export const deleteAutoLoanIndexSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.DELETE_AUTO_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const deleteAutoLoanIndexFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.DELETE_AUTO_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const deleteAutoLoanIndexResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.DELETE_AUTO_LOAN_PROPODAL_RESPONSE_RESET,
});

export const deleteAutoLoanIndexResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.DELETE_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ****************** END AUTO LOAN INDEX REVERT *********************************** */

/** ***************** GET DEALER LIST START *********************** */
export const getAllDealerListStart = (getData: any) => ({
	type: AutoLoanProposalActionTypes.GET_ALL_DEALER_LIST_START,
	payload: getData,
});

export const getAllDealerListSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.GET_ALL_DEALER_LIST_SUCCESS,
	payload: successData,
});

export const getAllDealerListFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.GET_ALL_DEALER_LIST_FAILURE,
	payload: failureData,
});

export const getAllDealerListReponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.GET_ALL_DEALER_LIST_RESPONSE_RESET,
});

export const getAllDealerListReponseChanged = () => ({
	type: AutoLoanProposalActionTypes.GET_ALL_DEALER_LIST__RESPONSE_CHANGED,
});

/** *****************  GET DEALER LIST END *********************** */

/** ***************** GET PERMANT PINCODE START *********************** */
export const getPermantPincodeStart = (getData: any) => ({
	type: AutoLoanProposalActionTypes.GET_PERMANT_PINCODE_START,
	payload: getData,
});

export const getPermantPincodeSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.GET_PERMANT_PINCODE_SUCCESS,
	payload: successData,
});

export const getPermantPincodeFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.GET_PERMANT_PINCODE_FAILURE,
	payload: failureData,
});

export const getPermantPincodeResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.GET_PERMANT_PINCODE_RESPONSE_RESET,
});

export const getPermantPincodeResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.GET_PERMANT_PINCODE__RESPONSE_CHANGED,
});
/** ***************** GET PERMANT PINCODE END *********************** */

/** ***************** CHECK AUTO LOAN MANDATORY DETAILS START *********************** */
export const checkAutoLoanMandatoryDetailsStart = (getData: any) => ({
	type: AutoLoanProposalActionTypes.CHECK_AUTOLOAN_MANDATORY_DETAILS_START,
	payload: getData,
});

export const checkAutoLoanMandatoryDetailsSuccess = (successData: any) => ({
	type: AutoLoanProposalActionTypes.CHECK_AUTOLOAN_MANDATORY_DETAILS_SUCCESS,
	payload: successData,
});

export const checkAutoLoanMandatoryDetailsFailure = (failureData: any) => ({
	type: AutoLoanProposalActionTypes.CHECK_AUTOLOAN_MANDATORY_DETAILS_FAILURE,
	payload: failureData,
});

export const checkAutoLoanMandatoryDetailsResponseResetStart = () => ({
	type: AutoLoanProposalActionTypes.CHECK_AUTOLOAN_MANDATORY_DETAILS_RESPONSE_RESET,
});

export const checkAutoLoanMandatoryDetailsResponseChanged = () => ({
	type: AutoLoanProposalActionTypes.CHECK_AUTOLOAN_MANDATORY_DETAILS__RESPONSE_CHANGED,
});
/** ***************** CHECK AUTO LOAN MANDATORY DETAILS END *********************** */
